// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, get, ref } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

import { setUser, signOut } from "./slices/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
const db = getDatabase(app);

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(app);

const functions = getFunctions(app);

export { app, auth, db, storage, functions, analytics };

// Helper function to extract serializable user data
const extractUserData = (user) => {
  return user ? { uid: user.uid, email: user.email } : null;
};

export const initializeAuthListener = (store) => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      // Fetch user info from Realtime Database
      const { uid } = user;
      const userRef = ref(db, "users/" + uid);
      const snapshot = await get(userRef);
      const userInfo = snapshot.val();
      store.dispatch(setUser({ ...extractUserData(user), ...userInfo }));
    } else {
      store.dispatch(signOut());
    }
  });
};
